import Vue from "vue";
// 提示
import toast from '@/components/toast'
Vue.use(toast);

// 复制
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)